import React from 'react';
import { Checkbox } from '@creditsights/styleguide-web';
import { ICellRendererParams } from '@ag-grid-community/core';

interface SelectColumnProps<TData, TId> extends ICellRendererParams<TData> {
  selected?: TId[];
  selectedAll: boolean;
  totalResults?: number;
  resultsLimit?: number;
  onSelect?: (ids: TId[]) => void;
  onSelectAll?: (toggle: boolean) => void;
}

// export const buildId = <T,>(row: T): string => `${row.packageId}/${row.groupId}`;

const SelectColumn = <TData extends { tagId: TId }, TId extends string>({
  data,
  selected,
  selectedAll,
  onSelect,
  onSelectAll,
  rowIndex,
  resultsLimit,
  totalResults = 0,
}: SelectColumnProps<TData, TId>): React.ReactNode => {
  if (!data && resultsLimit && totalResults > resultsLimit) {
    return null;
  }

  const checked = data ? selected?.includes(data.tagId) || selectedAll : selectedAll;
  const indeterminate = data ? false : !checked && !!selected?.length && selected.length !== totalResults;

  return (
    <Checkbox
      dataTestId={`company-select-${rowIndex}`}
      checked={checked}
      indeterminate={indeterminate}
      onChange={(_, checkboxData) => {
        let nextValue: TId[] = [];

        if (data) {
          nextValue = selected?.filter((id: TId) => id !== data.tagId) || [];

          if (checkboxData.checked) {
            nextValue = [...nextValue, data.tagId];
          }

          onSelect?.(nextValue);
          if (!checkboxData.checked && selectedAll) {
            onSelectAll?.(false);
          }
        } else {
          onSelectAll?.(!!checkboxData.checked);
          if (!checkboxData.checked) {
            onSelect?.([]);
          }
        }
      }}
    />
  );
};

export default SelectColumn;
